<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showRepsInfo") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Status Badges ==== -->

      <!-- ==== End:: Status Badges ==== -->
      <div v-if="!isRepresentativeLoading">
        <form>
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <div class="d-flex gap-2 justify-content-between flex-wrap ">
            <div class="preview-container text-center my-3">
              <h5>{{ $t("PLACEHOLDERS.representativeImage") }}</h5>
              <img
                v-if="data.image?.path"
                col="12"
                :src="data.image?.path"
                :alt="$t('PLACEHOLDERS.representativeImage')"
              />
            </div>

            <div class="preview-container text-center my-3">
              <h5>{{ $t("PLACEHOLDERS.id_imge") }}</h5>

              <img
                v-if="data.id_image?.path"
                col="12"
                :src="data.id_image?.path"
                :alt="$t('PLACEHOLDERS.id_imge')"
              />
            </div>
          </div>
          <!-- End:: Image Upload Input -->

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="data.name"
            disabled
          />

          <base-input
            col="6"
            type="text"
            v-model="data.phone"
            :placeholder="$t('PLACEHOLDERS.phone')"
            disabled
          />

          <base-input
          col="6"
          type="text"
          :placeholder="$t('PLACEHOLDERS.printerShop')"
          :value="data.print_shop || $t('PLACEHOLDERS.printerShopNotLinked')"
          disabled
          />
        </div>
        </form>
      </div>
      <div v-else class="d-flex justify-content-center my-5">
        <v-progress-circular
          indeterminate
          color="#3eb6d4"
          :size="40"
        />
      </div>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BasePhoneInput from "@/components/formInputs/BasePhoneInput.vue";
import ChangableMapComponent from "../../../components/general/ChangableMapComponent.vue";

export default {
  computed: {
    businessActivityTypes() {
      return [
        { id: "restaurant", name: this.$t("BUSINESS_TYPE.restaurant") },
        { id: "cafe", name: this.$t("BUSINESS_TYPE.cafe") },
        {
          id: "hotel_restaurant",
          name: this.$t("BUSINESS_TYPE.hotel_restaurant"),
        },
        { id: "supermarket", name: this.$t("BUSINESS_TYPE.supermarket") },
      ];
    },
    deferredOptions() {
      return [
        { id: "yes", name: this.$t("PLACEHOLDERS.yes"), value: 1 },
        { id: "no", name: this.$t("PLACEHOLDERS.no"), value: 0 },
      ];
    },
  },
  name: "CreateClient",
  components: {
    BasePhoneInput,
    ChangableMapComponent,
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      isRepresentativeLoading: false,
      // End:: Loader Control Data

      specializations: [],
      academic_stages: [],
      academic_years: [],
      brands: [],
      commercial_registration: null,
      // Start:: Data Collection To Send
      data: {
        print_shop: null,
        id_image: {
          path: null,
          file: null,
        

},
        business_activity_type: null,
        brand: [],
        lat: null,
        image: {
          path: null,
          file: null,
        },
        name: null,

        phone: null,
      },
      // End:: Data Collection To Send
    };
  },

  methods: {
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    // End:: Select Upload Image
    async getBrands() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `brands?page=0&limit=0&isActive=1`,
        });
        this.brands = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getData() {
      try {
        this.isRepresentativeLoading = true;
        let res = await this.$axios({
          method: "GET",
          url: `representatives/${this.$route.params?.id}`,
        });
        // Start:: Set Data
        this.data.name = res.data.data?.Representative?.user.name;
        this.data.phone = res.data.data?.Representative?.user.mobile;
        this.data.city = res.data.data?.Representative?.user?.city?.name;
        this.data.id_image.path = res.data.data?.Representative?.user?.id_image;
        this.data.print_shop =
          res.data.data?.Representative?.user.print_shop?.name;
        this.data.image.path = res.data.data?.Representative?.user.avatar;

        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      } finally {
        this.isRepresentativeLoading = false;
      }
    },
  },

  async created() {
    this.getData();
    this.getBrands();

    this.$nextTick(() => {
      this.data.phone = "";
    });
  },
};
</script>
<style>
.btn_wallet {
  color: rgb(49, 145, 58);
  padding: 8px 12px;
  border-radius: 4px;
  background: transparent;
  transition: all 0.3s ease;
}

.fad:before,
.fad:after {
  font-size: 22px;
}

.excel {
  background: darkgreen;
  padding: 7px 10px;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
}
</style>
